import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Wie lange auf eine Antwort gewartet wird, bevor die Anfrage abgebrochen
 * wird.
 *
 * Ohne Grenze wartet der Browser endlos - und das ist schlimmer als es
 * klingt: Er haelt zu einem Server nur etwa sechs gleichzeitige
 * Verbindungen. Bleiben ein paar Anfragen haengen, warten alle weiteren in
 * der Schlange, ohne den Server je zu erreichen. Von aussen sieht dann die
 * ganze Anwendung eingefroren aus, obwohl nur ein einziger Aufruf klemmt.
 *
 * Drei Minuten sind laenger als jeder Aufruf hier je dauern darf - der
 * langsamste ist die Sammelauswertung - und kurz genug, dass ein klemmender
 * Aufruf seinen Platz wieder freigibt.
 */
export const ZEITGRENZE_MS = 180000;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: ZEITGRENZE_MS,
});

export default api;
